export default "__VITE_ASSET__2KcE6B5W__"